export default __webpack_public_path__ + "static/media/Curve1.c7ef6c5f.svg";